import * as React from 'react';
import { createRoot } from 'react-dom/client';

import LoginPage from '@/pages/Login';
import { renderWithUiRoot, resolveReactMountContainer } from '@/js/wisemetering/ui/render_with_ui_root';

WiseMetering.Views.Login = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    onShow: function() {
        const container = resolveReactMountContainer(this);
        const root = createRoot(container);

        renderWithUiRoot(
            root,
            container,
            <LoginPage initialAuthState={this.options.initialAuthState} code={this.options.code}/>
        );
    }
});
